import type { Locale } from '@backmarket/http-api'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

export default function createListFormatter(locale: Locale) {
  return (list: string[], options?: Intl.ListFormatOptions) =>
    new Intl.ListFormat(toBcp47Locale(locale), options).format(list)
}
